import { type Config } from 'svgo'

export const PLACEHOLDER_COLOR = 'currentcolor' // to match svgo's casing
export const PLACEHOLDER_STROKE_WIDTH = 'currentStrokeWidth'

export const svgoConfig: Config = {
	multipass: true,
	plugins: [
		{
			name: 'inlineStyles',
			params: {
				onlyMatchedOnce: false,
			},
		},
		{
			name: 'convertStyleToAttrs',
		},
		{
			name: 'preset-default',
			params: {
				overrides: {
					convertColors: {
						currentColor: true,
					},
				},
			},
		},
		{
			name: 'removeDimensions',
		},
		{
			name: 'removeAttrs',
			params: {
				attrs: ['class'],
			},
		},
	],
}

/**
 * Post-processes SVGO output to apply color and stroke-width placeholders.
 * - Replaces non-'none' fill/stroke values with currentcolor
 * - Adds fill="currentcolor" to shape elements if no valid colors exist
 * - Replaces non-'0' stroke-width values with currentStrokeWidth
 */
export function postProcessSvg(svg: string): string {
	let result = svg

	// Check if there are valid color attributes (fill/stroke that aren't 'none')
	const hasElementsWithValidColors = /(fill|stroke)="(?!none)[^"]+"/i.test(result)

	if (result.includes('fill="') || result.includes('stroke="')) {
		result = result.replace(/(fill|stroke)="([^"]+)"/g, (match, attr, value) => {
			if (value === 'none') {
				return match
			}
			return `${attr}="${PLACEHOLDER_COLOR}"`
		})
	}

	if (!hasElementsWithValidColors) {
		result = result.replace(
			/<(path|circle|rect|line|polygon|polyline) /g,
			(match) => `<${match.slice(1)} fill="${PLACEHOLDER_COLOR}" `,
		)
	}

	result = result.replace(/stroke-width="([^"]+)"/g, (match, value) => {
		if (value === '0') {
			return match
		}
		return `stroke-width="${PLACEHOLDER_STROKE_WIDTH}"`
	})

	return result
}
